import { serialize } from "@/utils";

export default {
  namespaced: true,
  state: {
    path: "aljabr/telegram-api/teacher/warehouse-acts",
  },
  actions: {
    get({ dispatch, state, rootState }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    checkAndAssign({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/check-and-assign`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    checkAndAssignProductItem({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/check-and-assign-product-item`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    new({ dispatch, state, rootState }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/new`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
  },
};
